import { MetronomeStates } from '@arpeggi/shared'
import { observer } from 'mobx-react-lite'
import { useTreeState } from '../../../stores/Root'
import { IconButton } from '../../core/Components'
import { Metronome } from '../../core/icons'
import withTooltip from '../../core/withTooltip'
import { segmentStudioButton } from '../StudioUtils'

const ButtonWithTooltip = withTooltip(IconButton)

const MetronomeButton = () => {
  const { studio } = useTreeState()
  const { metronome, toggleMetronome } = studio
  const isActive = metronome === MetronomeStates.ACTIVE
  const label = isActive ? 'Disable Metronome' : 'Enable Metronome'
  return (
    <ButtonWithTooltip
      active={isActive}
      onClick={() => {
        toggleMetronome()
        segmentStudioButton('Toggle Metronome', 'studio header')
      }}
      tooltipText={label}
      css={{ marginRight: '16px' }}
    >
      <Metronome />
    </ButtonWithTooltip>
  )
}

export default observer(MetronomeButton)
